import {Route, Routes} from "react-router-dom";
import RequireAuth from "../../components/RequireAuth";
import {PermissionLevel} from "../../app/api/model/user";
import TerminationList from "./TerminationList";
import TerminationDetails from "./detail/TerminationDetails";

export default function Terminations() {
    return (
        <RequireAuth permissionLevel={PermissionLevel.VIEW_ONLY}>
            <Routes>
                <Route index element={<TerminationList />} />
                <Route path=":terminationId" element={<TerminationDetails />} />
            </Routes>
        </RequireAuth>
    );
}
